import React, { useState } from 'react';
import axios from 'axios';
import { Lock, Mail } from 'lucide-react';
import API_BASE from '../api';

const BRAND = '#c1009d';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim() || loading) return;
    setLoading(true);
    setError('');

    try {
      const res = await axios.post(`${API_BASE}/api/auth/login`, {
        username: username.trim(),
        password,
      });

      if (res.data && res.data.success) {
        localStorage.setItem(
          'letterly_admin_auth',
          JSON.stringify({
            id: res.data.user?.id,
            username: res.data.user?.username || username.trim(),
          }),
        );
        onLogin();
      } else {
        setError('No user found. Please check your username and password.');
      }
    } catch (err) {
      const status = err.response?.status;
      if (status === 401 || status === 404) {
        setError('No user found. Please check your username and password.');
      } else {
        setError(err.response?.data?.error || 'Unable to log in. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at top left, #fdf2ff 0, #f9fafb 45%, #eef2ff 100%)',
        padding: '1.5rem',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 440,
          background: '#ffffff',
          borderRadius: 24,
          padding: '2.2rem 2rem 2rem',
          boxShadow: '0 18px 45px rgba(15,23,42,0.16)',
          border: '1px solid rgba(148,163,184,0.3)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '1.75rem' }}>
          <div>
            <div
              style={{
                fontSize: '1.6rem',
                fontWeight: 700,
                color: '#111827',
                marginBottom: 4,
              }}
            >
              Letterly Admin
            </div>
            <div
              style={{
                fontSize: '0.82rem',
                color: '#6b7280',
              }}
            >
              Sign in to manage students and coaches
            </div>
          </div>
        </div>

        {error &&
          <div
            style={{
              marginBottom: '1rem',
              background: '#fef2f2',
              borderRadius: 10,
              padding: '0.75rem 0.9rem',
              border: '1px solid #fecaca',
              fontSize: '0.8rem',
              color: '#b91c1c',
            }}
          >
            {error}
          </div>
        }

        <form
          onSubmit={handleSubmit}
          style={{ display: 'flex', flexDirection: 'column', gap: '0.9rem' }}
        >
          <div>
            <label
              style={{
                display: 'block',
                fontSize: '0.8rem',
                fontWeight: 600,
                color: '#4b5563',
                marginBottom: 4,
              }}
            >
              Username
            </label>
            <div style={{ position: 'relative' }}>
              <Mail
                size={16}
                style={{
                  position: 'absolute',
                  left: 12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af',
                }}
              />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Letterlyadmin@gmail.com"
                style={{
                  width: '100%',
                  padding: '0.7rem 0.75rem 0.7rem 2.4rem',
                  borderRadius: 10,
                  border: '1px solid #d1d5db',
                  fontSize: '0.9rem',
                  outline: 'none',
                }}
              />
            </div>
          </div>

          <div>
            <label
              style={{
                display: 'block',
                fontSize: '0.8rem',
                fontWeight: 600,
                color: '#4b5563',
                marginBottom: 4,
              }}
            >
              Password
            </label>
            <div style={{ position: 'relative' }}>
              <Lock
                size={16}
                style={{
                  position: 'absolute',
                  left: 12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af',
                }}
              />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                style={{
                  width: '100%',
                  padding: '0.7rem 0.75rem 0.7rem 2.4rem',
                  borderRadius: 10,
                  border: '1px solid #d1d5db',
                  fontSize: '0.9rem',
                  outline: 'none',
                }}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading || !username.trim() || !password.trim()}
            className="btn btn-primary"
            style={{
              width: '100%',
              marginTop: '0.5rem',
              padding: '0.7rem 1rem',
              borderRadius: 999,
              fontSize: '0.9rem',
              fontWeight: 600,
              background:
                loading || !username.trim() || !password.trim()
                  ? '#e5e7eb'
                  : BRAND,
              border: 'none',
              color: '#ffffff',
              cursor:
                loading || !username.trim() || !password.trim()
                  ? 'not-allowed'
                  : 'pointer',
            }}
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;

